import { useTranslation } from 'react-i18next';

import { POSITION } from 'enums/common';
import useCalculatorState from 'hooks/useCalculatorState';
import useResults from 'hooks/useResults';

import { ReactComponent as SquareIcon } from '@icons/position-square.svg';

import styles from './styles';

export interface MeasureProps {
  value: number,
  position: POSITION,
}

const Measure = ({
  value,
  position,
} : MeasureProps) => {
  const {
    dimensions: {
      type: unitType,
    } = {},
  } = useCalculatorState();

  return (
    <div className={styles.measure(position)}>
      <SquareIcon />
      <span>
        {value}
        {' '}
        {unitType}
      </span>
    </div>
  );
};

const Measures = () => {
  const { t } = useTranslation();

  const results = useResults();

  const {
    widthDifference,
    lengthDifference,
  } = results || {};

  const widthOverhang = widthDifference > 0 ? Number(widthDifference) / 2 : 0;
  const lengthOverhang = lengthDifference > 0 ? Number(lengthDifference) / 2 : 0;

  return (widthOverhang || lengthOverhang) ? (
    <div className={styles.container}>
      <h3 className={styles.title}>{t('Overhang (per side):')}</h3>
      <div className={styles.measures}>
        <Measure value={widthOverhang} position={POSITION.LEFT} />
        <Measure value={widthOverhang} position={POSITION.RIGHT} />
        <Measure value={lengthOverhang} position={POSITION.TOP} />
        <Measure value={lengthOverhang} position={POSITION.BOTTOM} />
      </div>
    </div>
  ) : null;
};

export default Measures;
